(() => {
  'use strict';
  const normalize = value => String(value || '').normalize('NFKC').replace(/\s+/g, '');
  const notePattern = /定期便は最低\d回以上の購入が必須.*自動継続/;

  const getPurchaseMode = section => {
    const widgetMode = section.querySelector('.huckleberry-subscription-widget-container input[name="plan"]:checked');
    if (widgetMode) {
      if (/onetime|one.?time|single/i.test(widgetMode.value)) return 'one_time';
      if (/subscription|subscribe|recurring/i.test(widgetMode.value)) return 'subscription';
    }

    const selected = Array.from(section.querySelectorAll('input[type="radio"]:checked, [role="radio"][aria-checked="true"]'));
    for (const input of selected) {
      if (String(input.name || '').startsWith('options[')) continue;
      const label = (input.labels && Array.from(input.labels).map(x => x.textContent).join(' ')) || input.closest('label')?.textContent || '';
      const word = normalize(label);
      if (/単品購入|通常購入|今回だけ|一回のみ|今回のみ/.test(word)) return 'one_time';
      if (/定期購入|定期便/.test(word)) return 'subscription';
    }

    const group = section.querySelector('input[name="selling-plan-group"]:checked');
    if (group) return group.value ? 'subscription' : 'one_time';

    const plans = Array.from(section.querySelectorAll('input[name="selling_plan"]'));
    if (plans.some(input => (input.type !== 'radio' && input.type !== 'checkbox' || input.checked) && input.value && input.value !== '0')) {
      return 'subscription';
    }
    if (plans.length) return 'one_time';
    if (section.dataset.kiwabiHasSubscriptions === 'false') return 'one_time';
    return 'unknown';
  };

  const init = section => {
    if (section.dataset.kiwabiCompactProductReady === 'true') return;
    const options = section.querySelector('.product__block__variants');
    const box = section.querySelector('.selector-wrapper[data-select-label="セット本数"]');
    if (!options && !box) return;
    section.dataset.kiwabiCompactProductReady = 'true';

    const notes = Array.from(section.querySelectorAll('.product__block__text:not([data-kiwabi-purchase-notice])'))
      .filter(node => notePattern.test(normalize(node.textContent)));
    for (const note of notes) note.dataset.kiwabiMinimumOrderNotice = 'true';

    let frame = 0;
    const update = () => {
      frame = 0;
      const currentOptions = section.querySelector('.product__block__variants');
      const quantity = section.querySelector('.product__block__quantity');
      if (currentOptions && quantity && currentOptions.parentElement === quantity.parentElement && currentOptions.nextElementSibling !== quantity) {
        currentOptions.insertAdjacentElement('afterend', quantity);
      }

      if (!notes.length) return;
      const selectedBox = section.querySelector('.selector-wrapper[data-select-label="セット本数"]') || box;
      const selected = selectedBox?.querySelector('input[type="radio"]:checked, input[data-single-option-selector]');
      const packageName = normalize(selected?.value || '');
      const single = /^1本$/.test(packageName);
      const purchaseMode = getPurchaseMode(section);
      const shouldShow = single && purchaseMode !== 'one_time';
      notes.forEach(node => { node.hidden = !shouldShow; });
    };
    const queue = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };
    section.addEventListener('change', queue);
    section.addEventListener('input', queue);
    section.addEventListener('click', queue);
    section.addEventListener('theme:variant:change', queue);
    const target = section.querySelector('.product__main__content') || section;
    new MutationObserver(queue).observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked', 'aria-checked', 'value', 'class']
    });
    update();
  };

  const scan = root => {
    if (root.matches?.('[data-section-type="product"]')) init(root);
    root.querySelectorAll?.('[data-section-type="product"]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
